import React from 'react';
import '../StyleSheets/DropDown.css';

import MaterialIcon from 'material-icons-react';

export default class DropDown extends React.Component {

    render() {
        const { position, icon, options, value, onChange  } = this.props;

        const style = {
            position: "absolute",
            top: position.t,
            right: position.r,
        }

        return <div className="dropDownContainer" style={style}>

            <select className="dropDownButton" value={value} onChange={onChange}>
                {options.map( (opt,i) => {
                    return <option key={i + "_" + opt.key} value = {opt.key}>{opt.title}</option> 
                } )}
            </select>
            <div style={{zIndex: 3, margin: "6px 12px 6px 6px", pointerEvents: "none" }}>
                <MaterialIcon icon={icon} size = {24} color={ "#000000" }/>
            </div>
        </div>
        
    }

}